<template>
  <div class="block-form">
    <a
      v-b-toggle="`collapseBlock-${block.id}${block.type}`"
      :class="`btn btn-sm btn-${Object.values(block.relations).length ? 'success' : 'dark' } dis-ib`"
    >
      <i data-feather="corner-left-up" /> {{ Object.values(block.relations).length ? 'With' : 'Add' }} relationship
    </a>
    <b-collapse :id="`collapseBlock-${block.id}${block.type}`">
      <div class="mt-3">
        <div class="card shadow-none bg-transparent border-secondary">
          <div class="card-body">
            <h3>Add relationship</h3>
            <div
              v-for="(relation, index) in block.relations"
              :key="index"
              class="row d-flex align-items-end"
            >
              <div class="col-sm-4">
                <div class="mb-1">
                  <label
                    for="formFile"
                    class="form-label"
                  >Select form element</label>
                  <v-select
                    v-model="relation.block"
                    label="title"
                    :options="selects"
                    :get-option-key="option => option.title"
                    @input="relation.options = null"
                  />
                </div>
              </div>
              <div class="col-sm-4">
                <div class="mb-1">
                  <label
                    for=""
                    class="form-label"
                  >Condition</label>
                  <v-select
                    v-model="relation.options"
                    multiple
                    label="option"
                    :options="relation.block ? relation.block.options : []"
                    :get-option-key="option => option.option"
                  />
                </div>
              </div>
              <div class="col-sm-3">
                <div class="mb-1">
                  <label
                    for=""
                    class="form-label"
                  >Group</label>
                  <input
                    v-model="relation.group"
                    type="text"
                    class="form-control"
                  >
                </div>
              </div>
              <div class="col-sm-1">
                <div class="mb-1">
                  <a
                    class="btn bg-light-danger"
                    @click="removeRelation(index)"
                  ><i data-feather="trash-2" /></a>
                </div>
              </div>
            </div>
            <button
              type="button"
              class="btn btn-dark"
              @click="addRelation"
            >
              <i data-feather="plus" /> Add relationship
            </button>
          </div>
        </div>
      </div>
    </b-collapse>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { BCollapse } from 'bootstrap-vue'

export default {
  components: {
    BCollapse,
  },
  props: {
    block: { type: Object, required: true },
  },
  data() {
    return {
      selectedOne: [],
    }
  },
  computed: {
    ...mapGetters({
      fields: 'modals/tableSettingsFields',
      form: 'requestForms/item',
    }),
    selects() {
      return this.form.new_blocks.filter(e => e.type.toLowerCase() === 'several_options' && e.id !== this.block.id)
    },
  },
  mounted() {},
  methods: {
    addRelation() {
      this.block.relations.push({
        block: null,
        options: [],
      })
    },
    removeRelation(index) {
      this.block.relations.splice(index, 1)
    },
  },
}
</script>
